import React, { useState, useEffect, useCallback } from 'react'
import HopeOfflinePaymentResult from './HopeOfflinePaymentResult'
import DefaultOfflinePaymentResult from './DefaultOfflinePaymentResult'
import { API } from 'api/API';
import { BUSINESS_MESSAGES_URL } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import { Alert } from 'react-bootstrap';

const offlinePaymentResultComponents = {
    amtca: HopeOfflinePaymentResult,
    hope: HopeOfflinePaymentResult,
    default: DefaultOfflinePaymentResult
}
const OfflinePaymentResult = (props) => {

    const [offlinePmtMsg, setOfflinePmtMsg] = useState("");
    const [ errors, setErrors]= useState({});

    const fetchOfflinePaymentMessage = useCallback(async () => {
        try {
            let offlinePmtMsgResp = await API.get(BUSINESS_MESSAGES_URL+"/offlinepaymentmessage");
            setOfflinePmtMsg(offlinePmtMsgResp.data.offlinePaymentMessage);
        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setErrors(errors);
                return;
            }
        };
    })

    useEffect(() => {
        fetchOfflinePaymentMessage();
    }, [])


    let OfflinePaymentResult = offlinePaymentResultComponents[props.domain.toLowerCase()];
    if (!OfflinePaymentResult) {
        OfflinePaymentResult = offlinePaymentResultComponents['default'];
    }
    {errors && <Alert variant='danger'>{errors.message}</Alert>}
    return <OfflinePaymentResult offlinePmtMsg={offlinePmtMsg} />;
}

export default OfflinePaymentResult